import { useQuery } from "@apollo/client";
import { useParams } from "react-router-dom";

import {
  GET_PROVIDER_MATERIAL_TRACEABILITY,
  Table,
  ProviderMaterialTraceability,
} from "@jasper/shared";

const MaterialTraceabilityList = () => {
  const { group_id } = useParams();
  const { data, error } = useQuery(GET_PROVIDER_MATERIAL_TRACEABILITY, {
    variables: {
      where: {
        id: group_id,
      },
    },
  });

  if (!group_id || error) {
    return <>Error</>;
  }

  return (
    <>
      <Table
        columns={[
          "Item material",
          "First material (approval reference / brand / country / reference)",
          "Second material (approval reference / brand /country / reference)",
          "Translated name",
        ]}
        rows={(
          data?.getUserGroupsWhereUnique?.availableMaterialTraceabilities ?? []
        ).map((providerMaterialTraceability: ProviderMaterialTraceability) => [
          providerMaterialTraceability?.materialTraceability?.itemMaterialId,
          `
            ${providerMaterialTraceability?.materialTraceability?.firstMaterialApprovalReference ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.firstMaterialBrand ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.firstMaterialCountry ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.firstMaterialReference ?? "-"}
          `,
          `
            ${providerMaterialTraceability?.materialTraceability?.secondMaterialApprovalReference ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.secondMaterialBrand ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.secondMaterialCountry ?? "-"} /
            ${providerMaterialTraceability?.materialTraceability?.secondMaterialReference ?? "-"}
          `,
          providerMaterialTraceability.materialTraceability.translatedName,
        ])}
      />
    </>
  );
};

export default MaterialTraceabilityList;
